import { useEffect } from "react";

import "./curriculo.css";

import AOS from 'aos';
import 'aos/dist/aos.css';

import curriculo from "../../assets/icons/curriculo.png";

export default function Curriculo() {

  useEffect(() => {
    AOS.init();
  }, [])

  function goToCurriculo() {
    window.open(
      `https://drive.google.com/file/d/1Mp8L4q5DvMujvtDagx_HUpeABE1W-2dZ/view?usp=sharing`
    );
  }

  return (
      <div className="curriculo" id="curriculo">
        <p className="tittle curriculo--title" data-aos="fade-down">
          Currículo <strong>( )</strong>
        </p>

        <div className="curriculo--container">
          <div className="curriculo--image" data-aos="fade-right">
            <img src={curriculo} alt="" />
          </div>
          <div className="curriculo--info" data-aos="fade-left">
            <div className="info-content">
              <div className="content-label">
                <p>Nome</p>
                <p>Idade</p>
                <p>Cidade</p>
                <p>Telefone</p>
                <p>Email</p>
                <p>Freelance</p>
                <p>Exp.</p>
                <p>Idiomas</p>
              </div>
              <div className="content-text">
                <p>Leandro Salles</p>
                <p>32 anos</p>
                <p>Belo Horizonte - MG</p>
                <p>+55 (31) 9 9610-1036</p>
                <p>leandro.asalles182@gmail.com</p>
                <p>Disponível</p>
                <p>HTML, CSS, JS, React.js</p>
                <p>Inglês (intermediário)</p>
              </div>
            </div>
            <button className="primary-button curriculo--btn" onClick={goToCurriculo}>
              Baixe meu currículo completo
            </button>
          </div>
        </div>
      </div>
  );
}
